module.exports = {"id":"229071","name":"Karim Onisiwo","rating":"72","photo":"./data/images/photos/2/229071.png","club":{"name":"FSV Mayence 05","logo":"./data/images/clubs/FSVMayence05.png"},"positions":["MD","MG","BU","DD"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KarimOnisiwo0.json
// module id = 2291
// module chunks = 0